/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.collected.forms.rpc.CollectedFormsRpc
 */

export const PortalIdIsRequiredErrorTypename = 'com.hubspot.collectedforms.core.models.errors.PortalIdIsRequiredError';
export const getAllRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'getAll',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACyyJDProWzpmnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'hC4JmTs8dTkrvKVERByYOGnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByGuidRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'getByGuid',
  auth: 'app',
  fingerprint: 'waf1HPfcCwxaHp6mbih-tGnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const retrievePagedCollectedFormsRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'retrievePagedCollectedForms',
  auth: 'app',
  fingerprint: '8RtpujfdFEVkEUsIIinReWnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCollectedFormRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'updateCollectedForm',
  auth: 'app',
  fingerprint: 'OFt4v9nM4hvTFTeosFVJXmnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteByGuidRpc = {
  serviceName: 'com.hubspot.collected.forms.rpc.CollectedFormsRpc',
  rpcName: 'deleteByGuid',
  auth: 'app',
  fingerprint: 'CwYeqjyGaDNFQoNsprHIzWnVxB0v_rJn',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};